// @flow

import { useCallback, useState } from "react";
import { useModal as useQuantumModal } from "@quantum/ui";

export type ModalStateType = {
  open: any => mixed,
  close: any => mixed,
  hasEntered: boolean,
  onEntered: any => mixed,
  onExited: any => mixed,
  isOpen: boolean,
};

export const useModal = (props: *) => {
  const modal = useQuantumModal(props);
  const [entered, setEntered] = useState(false);
  return {
    ...modal,
    hasEntered: entered,
    onEntered: useCallback(() => setEntered(true), [setEntered]),
    onExited: useCallback(() => setEntered(false), [setEntered]),
  };
};

export const bindModal = (modalState: ModalStateType) => ({
  show: modalState.isOpen,
  onHide: modalState.close,
  onEntered: modalState.onEntered,
  onExited: modalState.onExited,
});

export const bindModalTrigger = (modalState: ModalStateType) => ({
  onClick: () => modalState.open(),
});
